export default __webpack_public_path__ + "static/tmb-1-893d87252ea4b06f0d1f484f3e22b432.png";